// Capabilities of the signed-in user as delivered by GET /me (server/config/permissions.js is the
// single source). Module-level so the plain-function menu model can ask without prop drilling;
// AuthContext sets it before the user state, so any render that knows the user also knows this.
let granted = new Set();
let isAdmin = false;
let branch = { aptId: null, hasBranchStock: false };

export function setPermissions(list, role, user = null) {
  granted = new Set(Array.isArray(list) ? list : []);
  isAdmin = role === "admin";
  branch = { aptId: user?.aptId ?? null, hasBranchStock: Boolean(user?.hasBranchStock) };
}

// Filial-Mitarbeiter: persoenlicher Account mit Filiale (z. B. apotheker/pta der Weissenburger).
// Der gemeinsame Filial-Account (apotheke) zaehlt nicht dazu.
export function isBranchStaff(role) {
  return branch.aptId != null && role !== "apotheke";
}

export function hasBranchStock() {
  return branch.hasBranchStock;
}

export function can(key) {
  return isAdmin || granted.has(key);
}
